<template>
  <div
    :class="{ 'Inquiry-intro__lead--application': isApplication }"
    class="Inquiry-intro"
  >
    <h1 class="Inquiry-intro__heading">{{ heading }}</h1>
    <em v-if="lead" class="Inquiry-intro__lead" v-html="lead" />
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      required: true
    },
    lead: {
      type: String,
      default: () => {
        return "";
      }
    },
    isApplication: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.Inquiry-intro {
  margin-bottom: $spacing-L;

  &__heading {
    @extend %title-L;
    margin: 0 0 $spacing 0;
  }
  &__lead {
    color: $color-brownish-grey;
    margin: $spacing $spacing $spacing 0;

    &--application {
      padding-right: $spacing-L * 2;
    }
  }
}
</style>
